module.exports = __webpack_public_path__ + "img/peking-duck-1.2dd76bbb.jpg";